import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import UserAvatar from '../../../User/Avatar';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
/** An avatar that will sit alongside our comment box. It's just our `<UserAvatar />` with some predefined fields. */ const CommentBoxAvatar = ({ withLink, className })=>{
    const currentUser = useCurrentUser();
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(UserAvatar, {
        user: currentUser,
        size: isMobile ? 24 : 32,
        className: className,
        withLink: withLink
    });
};
CommentBoxAvatar.displayName = 'CommentBoxAvatar';
export default CommentBoxAvatar;

//# sourceMappingURL=CommentBoxAvatar.js.map